import { sidebarConfig, useSidebarOpenState } from '@backstage/core-components';
import { Flex, Link } from '@backstage/ui';
import LogoFull from './logo/LogoFull';
import LogoIcon from './logo/LogoIcon';
import styles from './SidebarLogo.module.css';

// Bridge Backstage's runtime sidebar constants into the CSS Module, since CSS
// cannot read the JS `sidebarConfig` values. This keeps the sizing in sync with
// Backstage rather than hardcoding pixel values that could drift.
const sidebarLogoVars = {
  '--sidebar-width': `${sidebarConfig.drawerWidthClosed}px`,
  '--logo-height': `${3 * sidebarConfig.logoHeight}px`,
} as React.CSSProperties;

export const SidebarLogo = () => {
  const { isOpen } = useSidebarOpenState();

  return (
    <Flex className={styles.root} style={sidebarLogoVars} pl="6">
      <Link href="/" className={styles.link} aria-label="Home">
        {isOpen ? <LogoFull /> : <LogoIcon />}
      </Link>
    </Flex>
  );
};
